import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			dark: {
				primary: colors.shades.white,
			},
		},
		dark: true,
	},
	icons: {
		iconfont: 'md' || 'fa'
	}
});
